import SavingIndicator from './SavingIndicator';

export default SavingIndicator;
